import React, {Component} from 'react';

import formatters from "../../../../../utils/formatters";

export default class TripProgrammingForm extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;


        let estimated_load_date = trip.estimated_load_date;
        if(trip.estimated_load_date){
            estimated_load_date = formatters.dateFormat(trip.estimated_load_date);
        }

        let form = (
            <div className={"row"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Transporte</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s12 input-field"}>
                            <label className="active">Empresa Transportista</label>
                            <p className={"field-p truncate"}>{trip.carrier}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Patente Chasis</label>
                            <p className={"field-p"}>{trip.truck_plate}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Patente Acoplado</label>
                            <p className={"field-p"}>{trip.trailer_plate}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Chofer - Nombre y Apellido</label>
                            <p className={"field-p"}>{trip.driver_name}</p>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Licencia de Conducir</label>
                            <p className={"field-p"}>{trip.driver_doc}</p>
                        </div>
                    </div>
                    <div className={"row no-margin"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Observaciones</label>
                            <p className={"field-p truncate"}>{trip.business_observations}</p>
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Operación</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Tipo de Operación</label>
                                <p className={"field-p"}>{trip.operation_type.name}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Fecha estimada de Carga/Descarga</label>
                                <p className={"field-p"}>{estimated_load_date}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Producto</label>
                                <p className={"field-p"}>{trip.product.name}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Destino</label>
                                <p className={"field-p"}>{trip.terminal.name}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field "}>
                                <label className="active">Area de carga/descarga</label>
                                <p className={"field-p"}>{trip.destination_area.name}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Contacto</label>
                                <p className={"field-p"}>{trip.contact}</p>
                            </div>
                        </div>
                        <div className={"row no-margin"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Remito Contratista</label>
                                <p className={"field-p"}>{trip.provider_trip_receipt}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Remito Shell</label>
                                <p className={"field-p"}>{trip.shell_trip_receipt}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Viaje Ingresado</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/Done/TripProgrammingForm.js